module.exports = __webpack_public_path__ + "media/assets/images/layout/bg-header-bafeb5f85cdbe5099a995e94f5cc8302.jpg";